export default "__VITE_ASSET__DUDxeZGx__"